import { defineComponent as _defineComponent } from 'vue'
import MarketingCampaignSettings from '@/grpc-api/model/marketing-campaign-settings';
import localized from '@/plugins/vue-localized-formatter/src/localized';
import store from '@/store/store';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsletterQuotaBar',
  setup(__props) {


const settings = computed(() => store.getters.marketingCampaignSettings as MarketingCampaignSettings);


return { __sfc: true,settings, localized }
}

})